<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="customer-modal-option" :title="customer?.name" subtitle="Opciones disponibles" bodyClass="container-md vstack gap-5">
		<template #body v-if="customer">
			<CustomerCommonSummaryInfo :customer="customer" />
			<CustomerCommonProposalList :proposals="customer.pivot?.proposals" v-if="(customer.pivot?.proposals ?? []).length > 0" />
			<CustomerCommonHistoryList :histories="customer.pivot?.histories" />
		</template>
		<template #footer>
			<router-link :to="{ name: 'propostal.form', query: { company_id: customer?.company_id, customer_id: customer?.id }}" class="btn btn-outline-warning rounded-pill" v-if="canProposal">Propuesta</router-link>
			<button type="button" class="btn btn-outline-primary rounded-pill" @click="contact">Contactar</button>
			<button type="button" class="btn btn-primary rounded-pill" @click="status">Cambiar</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, computed, onMounted, getCurrentInstance } from 'vue';
	import { Modal, Offcanvas } from 'bootstrap';

	export default {
		setup(props) {
			const instance = getCurrentInstance();
			const offcanvas = ref(null);
			const customer = ref(null);

			const canProposal = computed(() => (customer.value?.company?.capabilities ?? []).includes('proposal:order'));

			const closeOpenOffcanvas = () => {
				if(document.querySelector('.offcanvas.show')) {
					var offcanvasShowed = Offcanvas.getInstance(document.querySelector('.offcanvas.show'));
					offcanvasShowed.hide();
				}

				if(document.querySelector('.modal.show')) {
					var modalShowed = Modal.getInstance(document.querySelector('.modal.show'));
					modalShowed.hide();
				}
			}

			const customerOption = (dataCustomer = null) => {
				closeOpenOffcanvas();
				customer.value = dataCustomer;
				offcanvas.value.offcanvas.show();
			}

			const status = () => {
				offcanvas.value.offcanvas.hide();
				instance.proxy.$customerStatus(customer.value);
			}

			const contact = () => {
				offcanvas.value.offcanvas.hide();
				instance.proxy.$customerContact(customer.value, { register: true });
			}

			onMounted(() => {
				if(instance) instance.appContext.config.globalProperties.$customerOption = customerOption;
			});

			return { customer, canProposal, offcanvas, status, contact };
		}
	}
</script>